module.exports = __webpack_public_path__ + "static/media/add-card-visaa.98549f4c.svg";